/* unplugin-vue-components disabled */import { render } from "./question-vertical-select.vue?vue&type=template&id=2fae454c&scoped=true"
import script from "./question-vertical-select.vue?vue&type=script&lang=js"
export * from "./question-vertical-select.vue?vue&type=script&lang=js"

import "./question-vertical-select.vue?vue&type=style&index=0&id=2fae454c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fae454c"],['__file',"src/components/chat-input-v2/question/question-vertical-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fae454c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fae454c', __exports__)) {
    api.reload('2fae454c', __exports__)
  }
  
  module.hot.accept("./question-vertical-select.vue?vue&type=template&id=2fae454c&scoped=true", () => {
    api.rerender('2fae454c', render)
  })

}


export default __exports__